import { useState } from "react"

import useAllProducts from "../../../hooks/useAllProducts"

const endpoint = `https://${process.env.GATSBY_MYSHOPIFY_DOMAIN}/api/2022-07/graphql.json`
const token = process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN || ""

interface IUseRecommendedProducts {
  productId: string
}

const useRecommendedProducts = ({ productId }: IUseRecommendedProducts) => {
  const allProducts = useAllProducts()

  const initialState = {
    loading: false,
    recommendedProducts: null,
    error: null,
    called: false,
  }

  const [state, setState] = useState(initialState)
  if (typeof window === "undefined") {
    return state
  }
  if (!state.called) {
    setState({ ...state, loading: true, called: true })

    fetch(endpoint, {
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token,
      },
      method: "POST",
      body: JSON.stringify({
        query: /* GraphQL */ `
          query ProductRecommendations($productId: ID!) {
            productRecommendations(productId: $productId) {
              id
            }
          }
        `,
        variables: {
          productId,
        },
      }),
    })
      .then(async response => {
        const json = await response.json()

        const matchedProducts = []

        json?.data?.productRecommendations?.forEach?.(({ id }) => {
          const matchedProduct = allProducts?.find(
            product => product?.shopifyId === id
          )
          if (matchedProduct) {
            matchedProducts?.push?.(matchedProduct)
          }
        })

        setState({
          ...state,
          recommendedProducts: matchedProducts,
          loading: false,
          called: true,
        })

        return json
      })
      .catch(err => {
        console.warn({ err })

        setState({
          ...state,
          recommendedProducts: null,
          loading: false,
          error: err,
          called: true,
        })
      })
  }

  return state
}

export default useRecommendedProducts
